// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"94156bc9","758":"f7c4fef3","787":"ba4a8c28","935":"84fa5254","974":"7f17c65a"}[chunkId] + ".chunk.js";
};